
import React from 'react'
import PropTypes from 'prop-types';

import {servidor, servicioRestful, terminalCodigo, intervaloReloj} from './Configuracion'

import {Button, Classes, Dialog, FormGroup, InputGroup, Tooltip, Intent} from "@blueprintjs/core";
import ClienteRestful from "../framework/ClienteRestful";
import connect from "react-redux/es/connect/connect";
import TabOrderManager from "../framework/TabOrderManager";
import "./resources/css/formulariomarcaje.css"
import Dialogo from "../framework/blueprint/Dialogo";
import {sha256} from "js-sha256";
import {getMinutosEntreDates, getFormattedDateTimeFromCadenaISO, getFormattedISO8601FromTimestamp} from "../framework/DateUtils"
import Clock from 'react-clock';
import DigitalClock  from 'react-live-clock';
import {estadoChangePagina, estadoChangePersonal, PAGE_MARCAJERESULTADO} from "./redux/estado/actions";
import {Spinner} from "@blueprintjs/core";
import MarcajesDia from "./MarcajesDia";

class FormularioMarcaje extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            date: new Date(),
            idfiscal: "",
            magicword: "",
            dialogoTitulo: "",
            dialogoTexto: "",
            dialogoTipo: "",
            cargandoDatos: false,

            mostrarMarcajesHoy: false,
            marcajesHoy: [],
        }
        this.tabOrderManager= new TabOrderManager(props.elementoConfig);
        this.tabOrderManager.addTabOrder("idfiscal", 1);
        this.tabOrderManager.addTabOrder("magicword", 2);
    }

    componentDidMount() {
        console.log("ComponentDidMount: ", intervaloReloj)
        setInterval(
            () => {
                console.log("Reloj");
                this.setState({ date: new Date() })
            },
            intervaloReloj * 1000
        );
    }

    componentDidUpdate() {
        //Tenemos que hacer la llamada aquí porque es el punto en el que se han cargado los refs correctamente
        this.tabOrderManager.setFocusInicial();

    }


    keyPress= (target, campoNombre) =>{
        if(this.tabOrderManager && target.charCode===13){
            console.log(campoNombre);
            if (campoNombre === "magicword")
                this.onAceptar();
            else
                this.tabOrderManager.setFocusSiguiente(campoNombre);
        }
    }

    onAceptar= () =>{

        /*
        var hash2 = sha256('jms');
        console.log("Hash: ");
        console.log(hash2);
        */

        if (this.validar())
            this.enviar();

    }

    validar= () => {
        const {idfiscal, magicword} = this.state;
        let valido= idfiscal && magicword;
        let camposIncorrectos= [];
        if (!idfiscal)
            camposIncorrectos.push("NIF");
        if (!magicword)
            camposIncorrectos.push("Contraseña");

        if (!valido){
            let dialogoTexto= camposIncorrectos.join(", ");
            dialogoTexto= "Los siguientes campos obligatorios no han sido completados: \r\n" + dialogoTexto;
            this.setState({dialogoTitulo: "Campos incorrectos", dialogoTexto: dialogoTexto, dialogoTipo: "ERROR"});
        }

        return valido;
    }

    enviar= () => {
        const {idfiscal, magicword} = this.state;
        const {terminalWebCodigo} = this.props;

        if (!this.validar())
            return;

        //let dateString= getFormattedISO8601FromTimestamp(new Date());
        let dateString= "";
        let marcaje= {
            "fecha": dateString, //"2020-03-25T11:10:00.000Z",
            "token": magicword,
            "idFiscal": idfiscal,
            //"terminalMarcajeCodigo": terminalCodigo,
            "terminalMarcajeCodigo": terminalWebCodigo,
            "terminalInfo":"Web",
            "tipoMarcaje": 1
        }

        console.log("ENVIAR:");
        console.log("marcaje: ", marcaje);

        this.setState({cargandoDatos: true});

        let urlPost= servidor + "time/addMarcajeWeb";
        const clienteRestful = new ClienteRestful().setUrl(urlPost);
        clienteRestful.doPost(marcaje, response => {
            this.setState({cargandoDatos: false});

            if (clienteRestful.exito && response) {
                let personal={
                    nombre: response.personalNombre,
                    fecha: response.fecha,
                }
                console.log("Correcto");
                this.props.dispatch(estadoChangePersonal(personal));
                this.props.dispatch(estadoChangePagina(PAGE_MARCAJERESULTADO));

            }
            else{
                console.log("Incorrecto");
                this.props.dispatch(estadoChangePersonal(null));
                this.props.dispatch(estadoChangePagina(PAGE_MARCAJERESULTADO));
            }

        });

    }

    loadMarcajesPersonalHoy= () => {
        const {idfiscal, magicword} = this.state;

        if (!this.validar())
            return;

        console.log("Load Personal Dia:");
        let parametros= {
            "token": magicword,
            "idFiscal": idfiscal,
        }

        let url= servidor + "time/marcajespersonalhoy/";
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doPost(parametros, response => {
            console.log(response);
            console.log("clienteRestful.exito: ", clienteRestful.exito);
            if (clienteRestful.exito)
                this.setState({mostrarMarcajesHoy: true, marcajesHoy: response});
        });
    }


    onCloseDialogoInvalido= () => {
        this.setState({dialogoTitulo: null, dialogoTexto: null, dialogoTipo: null} );
    }

    render() {
        const {date, nif, magicword, dialogoTitulo, dialogoTexto, dialogoTipo, diferenciaMinutosFechaServidor,
        cargandoDatos, mostrarMarcajesHoy, marcajesHoy} = this.state;

        console.log(" FORMULARIOMARCAJE RENDER");
        console.log("mostrarMarcajesHoy: ", mostrarMarcajesHoy);
        console.log("marcajesHoy: ", marcajesHoy);

        return (
            <>
                <Dialogo titulo={dialogoTitulo} mensaje={dialogoTexto} tipo={dialogoTipo} onClose={this.onCloseDialogoInvalido}/>
                {Boolean(mostrarMarcajesHoy) && <MarcajesDia
                    visible={mostrarMarcajesHoy}
                    marcajes={marcajesHoy}
                    onAccept={() => this.setState({mostrarMarcajesHoy: false})}/>  }

                <div className="reloj">
                    <Clock size={200}  value={date}  renderSecondHand={false}/>
                    <DigitalClock style={{fontSize:20}} format={'HH:mm:ss'} ticking={true}/>
                </div>

                { cargandoDatos &&  <Spinner intent={Intent.PRIMARY} size={50} /> }
                { !Boolean(cargandoDatos) &&
                <div className="formulariomarcaje">
                    <FormGroup key="idFiscal" label= "Identificador fiscal (NIF)" labelFor="igidfiscal" labelInfo="*">
                        <InputGroup
                            id= "igIdFiscal"
                            leftIcon= "person"
                            placeholder= "Introduzca el NIF"
                            value={nif}
                            onChange={ (event) => this.setState({idfiscal: event.target.value})  }
                            inputRef={this.tabOrderManager.getRef("idfiscal")}
                            onKeyPress={(target) => {this.keyPress(target, "idfiscal")}}
                        />
                    </FormGroup>

                    <FormGroup key="magicword" label= "Contraseña" labelFor="ifmagicword" labelInfo="*">
                        <InputGroup
                            id= "igmagicword"
                            leftIcon= "key"
                            placeholder= "Introduzca la contraseña"
                            value={magicword}
                            type={"password"}
                            onChange={ (event) => this.setState({magicword: event.target.value})  }
                            inputRef={ this.tabOrderManager.getRef("magicword")}
                            onKeyPress={(target) => {this.keyPress(target, "magicword")}}

                        />
                    </FormGroup>
                    <div>
                        <div style={{textAlign: "center"}}>
                            <Button  large={true} icon="refresh" intent="success" onClick={this.onAceptar}>Enviar</Button>
                        </div>
                        <div style={{marginTop: 20, textAlign: "right"}}>
                            <Button  icon="pin" intent="warning" onClick={this.loadMarcajesPersonalHoy}>Marcajes hoy</Button>
                        </div>
                    </div>
                </div>
                }


            </>
        )
    }
}

/*

 */

FormularioMarcaje.propTypes = {
    sedeCodigo: PropTypes.number,
    terminalWebCodigo: PropTypes.number,
}
const mapStateToProps = function(state) {
    return {
        estado: state.estado,
    }
}

export default connect(mapStateToProps)(FormularioMarcaje);
